/**
 *  请求的封装
 */
/* eslint-disable */
import axios from 'axios'
import { baseUrl } from './config'
import { Loading } from "element-ui";
import Vue from 'vue';
import VueCookies from 'vue-cookies';
 
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlenconded';

const load_config = {
    fullscreen: true,
    customClass: "full-loading",
    background: 'rgba(0, 0, 0, 0.8)'
}

// get
export function get(url, param, load=false, config = {}) {
    var loading;
    if (load) {
        loading = Loading.service(load_config)
    }
    return new Promise((resolve, reject) => {
        axios.get(url, {params: param, ...config}).then(res => {
            tokenCheck(res.data);
            resolve(res.data);
            if (load) {
                loading.close()
            }
        }).catch(err => {
            reject(err)
        })
    })
}

// post
export function post(url, param, load=false, config = {}) {
    var loading;
    if (load) {
        loading = Loading.service(load_config)
    }
    return new Promise((resolve, reject) => {
        axios.post(url, param, config).then(res => {
            tokenCheck(res.data);
            resolve(res.data);
            if (load) {
                loading.close()
            }
        })
    })
}

// put
export function put(url, param) {
    return new Promise((resolve, reject) => {
         
        axios.put(url, param).then(res => {
            tokenCheck(res.data);
            resolve(res.data);
        }).catch(error => {
            reject(error);
        })
    })
}

// delete
export function del(url, param) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {params: param}).then(res => {
            tokenCheck(res.data);
            resolve(res.data);
            
        }).catch(err => {
            reject(err.data);
        })
    })
}

// post
export function post_(url, param, config) {
    var loading = Loading.service({ fullscreen: true })
    return new Promise((resolve, reject) => {
        axios.post(url, param, config).then(res => {
            tokenCheck(res.data);
            resolve(res.data);
            loading.close()
        })
    })
}

export function post_body(url, param, config) {
    console.log('post_body')
    return axios({
        url: url,
        method: 'post',
        data: JSON.stringify(param)
    })
}


// token 检验
function tokenCheck(data) {
    if (data.code == 3) {
        location.href = '/login';
        VueCookies.set('token', '')
    }
}


export default axios;
